export default __webpack_public_path__ + "static/media/x-icon.c30e14ab.svg";